export default {
  SIGNS_PRACTICE: "Signs Practice",
  TIMESUP: "Time's up",
  START_GAME: "Start the Game!",
};
